import { ChangeDetectionStrategy, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { get } from 'lodash';

@Component({
  selector: 'gen-info-lines',
  templateUrl: './info-lines.component.html',
  styleUrls: ['./info-lines.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoLinesComponent implements OnInit {

  @Input()
  title: string;
  @Input()
  fieldsToDisplay: { value: string, cssClass?: string}[];
  @Input()
  translationPrefix?: string;

  private _sourceData: any;

  lines: {
    title: string;
    value: string | Date;
    type?: string;
    cssClass: string;
  }[] = [];

  constructor() {
  }

  ngOnInit() {
    if (this._sourceData) {
      this.init();
    }
  }


  @Input() set sourceData(data) {
      this._sourceData = data;
      if (this.fieldsToDisplay) {
        if (this._sourceData) {
          this.init();
        }
      }
  }

  init() {
      this.lines = this.fieldsToDisplay.map(field => {
        const fieldName = field.value;
        const fieldValue = get(this._sourceData, fieldName);
        return {
          title: this.translationPrefix ? `${this.translationPrefix}.${fieldName}` : fieldName,
          value: fieldValue === null ? '' : fieldValue,
          type: fieldValue instanceof Date ? 'date' : 'string',
          cssClass: field.cssClass
        };
      });
    }



}
